import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { unidadesColumns } from './columns/_columns'
import { UnidadeList } from '../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

export const UnidadesTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => unidadesColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={
        filters.unidade
          ? `Nenhuma unidade encontrada para “${filters.unidade}”`
          : `Nenhuma unidade nesta ${t('empresa.label.lowercase')}`
      }
      description={`Revise o termo digitado ou a ${t('empresa.label.lowercase')} selecionada.`}
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma unidade cadastrada'
      description='Use “Adicionar” para cadastrar a primeira unidade/setor.'
    />
  )

  return (
    <CustomTable<UnidadeList>
      id='kt_table_unidades'
      ariaLabel='Unidades/Setores'
      itemLabel={{ singular: t('unidade.label.lowercase'), plural: t('unidade.plural.lowercase') }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
